<template>
  <v-app
    style="width: 100%"
    class="pt-0 payflow-app"
    :class="{ 'payflow-app--mobile': !isDesktopLayout }"
  >
    <v-overlay :value="loading && !items" absolute opacity="0.6">
      <v-progress-circular indeterminate color="#0066FF" size="48" />
    </v-overlay>

    <template v-if="id && items">
      <pay-flow-desktop
        v-if="isDesktopLayout"
        ref="flowView"
        v-bind="flowProps"
        @select-gateway="gateway = $event"
        @pay="handlePayment"
        @print="printInvoice"
        @print-invoice="printInvoice"
        @download-pdf="downloadPdf"
        @share="shareInvoiceLink"
      />
      <pay-flow-mobile
        v-else
        ref="flowView"
        v-bind="flowProps"
        :shop-name="shopName"
        :display-number="displayNumber"
        @select-gateway="gateway = $event"
        @pay="handlePayment"
        @print="printInvoice"
        @print-invoice="printInvoice"
        @download-pdf="downloadPdf"
        @share="shareInvoiceLink"
      />
    </template>

    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import store from "../../../../../store";
import General from "../../../../../Mixins/general";
import PayFlowDesktop from "./PayFlowDesktop.vue";
import PayFlowMobile from "./PayFlowMobile.vue";

const PAYFLOW_DESKTOP_MIN_WIDTH = 800;
const PAYFLOW_PRINT_VIEWPORT_WIDTH = 1100;
const PAYFLOW_A4_PAGE = {
  WIDTH_MM: 210,
  HEIGHT_MM: 297,
  MARGIN_MM: 12,
};

export default {
  name: "GeneralPrintNew",
  components: { PayFlowDesktop, PayFlowMobile },
  mixins: [General],
  props: ["idProp"],
  data() {
    return {
      items: [],
      printType: "unofficial",
      gateway: null,
      type: null,
      content: null,
      id: null,
      date: null,
      number: null,
      officialNumber: null,
      currencyName: "",
      self: null,
      customer: null,
      loading: false,
      headers: null,
      price: null,
      payed: null,
      totalDiscount: null,
      totalPrice: null,
      decimal: 0,
      base64Logo: null,
    };
  },
  computed: {
    isDesktopLayout() {
      return this.$vuetify.breakpoint.width >= PAYFLOW_DESKTOP_MIN_WIDTH;
    },
    qrCodeUrl() {
      if (!this.invoiceShareLink) return null;
      return `https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(
        this.invoiceShareLink
      )}&size=240x240`;
    },
    invoiceShareLink() {
      if (!this.id) return null;
      const cuid = this.$route.query.cuid ? `?cuid=${this.$route.query.cuid}` : "";
      return `${window.location.origin}/print/invoice/${this.id}${cuid}`;
    },
    availableGateways() {
      if (!this.self) return [];
      const gateways = [];
      if (this.self.zibal) {
        gateways.push({
          value: "paymentZibalSystem",
          logo: require("@/assets/zibal.svg"),
          name: "زیبال",
          englishName: "Zibal",
        });
      }
      if (this.self.zarinpal) {
        gateways.push({
          value: "paymentZarinpalSystem",
          logo: require("@/assets/zarinpal.svg"),
          name: "زرین‌پال",
          englishName: "Zarinpal",
        });
      }
      if (this.self.karina) {
        gateways.push({
          value: "paymentKarinaSystem",
          logo: require("@/assets/karina.jpeg"),
          name: "کارینا",
          englishName: "Karina",
        });
      }
      return gateways;
    },
    needsPayment() {
      if (!this.type || (this.type !== "sell" && this.type !== "presale")) return false;
      if (!this.payed) return true;
      return this.price && this.payed.amount < this.price.price;
    },
    isFullyPaid() {
      return this.payed && this.price && this.payed.amount >= this.price.price;
    },
    remainingAmount() {
      if (!this.price) return this.totalPrice || 0;
      const paid = this.payed ? this.payed.amount : 0;
      return Math.max(0, this.price.price - paid);
    },
    totals() {
      if (!this.items || !this.items.length) {
        return { count: 0, fee: 0, discount: 0, tax: 0 };
      }
      return this.items.reduce(
        (acc, d) => {
          acc.count += parseFloat(d.count);
          acc.fee += parseFloat(d.fee) * parseFloat(d.count);
          acc.discount += parseFloat(d.discount);
          acc.tax += parseFloat(d.tax);
          return acc;
        },
        { count: 0, fee: 0, discount: 0, tax: 0 }
      );
    },
    showPaymentPanel() {
      return this.self && this.self.onlineInvoice === "active";
    },
    shopName() {
      return this.self && this.self.abrName ? this.self.abrName : "";
    },
    displayNumber() {
      return this.officialNumber || this.number || "";
    },
    flowProps() {
      return {
        headers: this.headers,
        items: this.items,
        content: this.content,
        currencyName: this.currencyName,
        totals: this.totals,
        totalDiscount: this.totalDiscount,
        remainingAmount: this.remainingAmount,
        availableGateways: this.availableGateways,
        gateway: this.gateway,
        loading: this.loading,
        needsPayment: this.needsPayment,
        isFullyPaid: this.isFullyPaid,
        showPaymentPanel: this.showPaymentPanel,
        qrCodeUrl: this.qrCodeUrl,
        self: this.self,
        customer: this.customer,
        date: this.date,
        displayNumber: this.displayNumber,
        shopName: this.shopName,
      };
    },
  },
  watch: {
    availableGateways(gateways) {
      if (!gateways.length) {
        this.gateway = null;
        return;
      }
      const isCurrentValid = gateways.some((g) => g.value === this.gateway);
      if (!isCurrentValid) {
        this.gateway = gateways[0].value;
      }
    },
    isDesktopLayout() {
      this.$nextTick(() => this.setheader());
    },
  },
  beforeMount() {
    this.tableHeader();
    // if (this.isPayFlowRoute && this.$route.params.id) {
    if (this.isPayFlowRoute() && this.$route.params.id) {
      this.id = this.$route.params.id;
      this.show();
    }
    if (this.idProp) {
      this.id = this.idProp;
      this.show();
    }
  },
  methods: {
    isPayFlowRoute() {
      return this.$route.name === "generalPrint" || this.$route.name === "generalPrintV2";
    },
    tableHeader() {
      this.headers = [
        {
          text: this.$t("row"),
          align: "center",
          sortable: false,
          value: "row",
          width: 20,
        },
        {
          text: this.$t("product") + "/" + this.$t("service"),
          sortable: false,
          value: "product",
          align: "center",
        },
        { text: this.$t("unit"), sortable: false, value: "unit", align: "center" },
        { text: this.$t("count"), sortable: false, value: "count", align: "center" },
        {
          text: this.$t("fee") + "(" + this.currencyName + ")",
          sortable: false,
          value: "fee",
          align: "center",
        },
        {
          text: this.$t("discount") + "(" + this.currencyName + ")",
          sortable: false,
          value: "discount",
          align: "center",
        },
        {
          text: this.$t("tax") + "(" + this.currencyName + ")",
          sortable: false,
          value: "tax",
          align: "center",
        },
        {
          text: this.$t("sum") + "(" + this.currencyName + ")",
          sortable: false,
          value: "sum",
          align: "center",
        },
      ];
    },
    getTableRef() {
      const view = this.$refs.flowView;
      if (!view || !view.$refs.table) return null;
      const tableRef = view.$refs.table;
      return tableRef.$refs && tableRef.$refs.table ? tableRef.$refs.table : tableRef;
    },
    getPrintLogoSrc() {
      if (this.base64Logo) {
        return "data:image/png;base64," + this.base64Logo;
      }
      if (this.self && this.self.logo && this.self.logo.link) {
        return this.self.logo.link;
      }
      return "";
    },
    getBase64Logo() {
      if (!this.self || !this.self.logo || !this.self.logo.link) {
        return Promise.resolve(null);
      }
      if (this.base64Logo) {
        return Promise.resolve(this.base64Logo);
      }
      return this.$axios
        .get(this.$endpoint + "getdetail?select=urlToBase64&url=" + this.self.logo.link)
        .then((res) => {
          this.base64Logo = res.data;
          return this.base64Logo;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
          return null;
        });
    },
    setheader() {
      const tableRef = this.getTableRef();
      if (!tableRef || !this.self) return;

      const elm = tableRef.$el.querySelector(".v-data-table-header");
      if (!elm) return;

      const existingCustom = elm.querySelectorAll(".payflow-header-row");
      existingCustom.forEach((row) => row.remove());

      const tr1 = document.createElement("tr");
      tr1.className = "payflow-header-row";
      tr1.innerHTML =
        '<th colspan="8">' +
        '<div style="display: flex;padding: 10px">' +
        '<div style="width: 33.33%">' +
        '<div align="right"><img class="mx-1" src="' +
        this.getPrintLogoSrc() +
        '" width="50"></div>' +
        "</div>" +
        '<div style="width: 33.33%">' +
        '<div align="center" style="font-size: 16px">' +
        this.$t(this.type) +
        "</div>" +
        '<div align="center">' +
        this.self.abrName +
        "</div>" +
        "</div>" +
        '<div style="width: 33.33%">' +
        '<div align="left">' +
        this.$t("date") +
        ": " +
        this.date +
        "</div>" +
        '<div align="left">' +
        this.$t("number") +
        ": " +
        (this.officialNumber ? this.officialNumber : this.number) +
        "</div>" +
        "</div>" +
        "</div>" +
        "</th>";

      const tr2 = document.createElement("tr");
      tr2.className = "payflow-header-row";

      if (this.printType === "official") {
        tr2.innerHTML =
          '<th colspan="6" style="padding: 6px 6px">' +
          '<div align="right">' +
          this.$t("seller") +
          ": " +
          this.self.abrName +
          "</div>" +
          '<div align="right">' +
          this.$t("phone") +
          ": " +
          (this.self.phone || "") +
          "</div>" +
          '<div align="right">' +
          this.$t("mobile") +
          ": " +
          (this.self.mobile || "") +
          "</div>" +
          '<div align="right">' +
          this.$t("address") +
          ": " +
          (this.self.address || "") +
          "</div>" +
          "</th>" +
          '<th colspan="2" style="padding: 6px 6px">' +
          '<div align="right">' +
          this.$t("buyer") +
          ": " +
          (this.customer && this.customer.gender ? this.$t(this.customer.gender) : "") +
          " " +
          (this.customer ? this.customer.name : "") +
          "</div>" +
          '<div align="right">' +
          this.$t("phone") +
          ": " +
          (this.customer && this.customer.phone ? this.customer.phone : "") +
          "</div>" +
          '<div align="right">' +
          this.$t("mobile") +
          ": " +
          (this.customer && this.customer.mobile ? this.customer.mobile : "") +
          "</div>" +
          '<div align="right">' +
          this.$t("address") +
          ": " +
          (this.customer && this.customer.address ? this.customer.address : "") +
          "</div>" +
          "</th>";
      } else {
        tr2.innerHTML =
          '<th colspan="8" style="padding: 6px 6px">' +
          '<div align="right">' +
          this.$t("buyer") +
          ": " +
          (this.customer && this.customer.gender ? this.$t(this.customer.gender) : "") +
          " " +
          (this.customer ? this.customer.name : "") +
          "</div>" +
          '<div align="right">' +
          this.$t("phone") +
          ": " +
          (this.customer && this.customer.phone ? this.customer.phone : "") +
          "</div>" +
          '<div align="right">' +
          this.$t("mobile") +
          ": " +
          (this.customer && this.customer.mobile ? this.customer.mobile : "") +
          "</div>" +
          '<div align="right">' +
          this.$t("address") +
          ": " +
          (this.customer && this.customer.address ? this.customer.address : "") +
          "</div>" +
          "</th>";
      }

      elm.prepend(tr2);
      elm.prepend(tr1);
    },
    show() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$apipoint + "print/invoice/" + this.id, {
          params: {
            id: this.idProp,
            print: "active",
            cuid: app.$route.query.cuid,
          },
        })
        .then((res) => {
          app.$nextTick(() => {
            res = res.data;
            app.id = res.id;
            app.currencyName = res.currency.name;
            app.tableHeader();
            app.number = res.number;
            app.officialNumber = res.official_number;
            app.content = res.content;
            app.date = res.date;
            app.type = res.type;
            app.items = res.article;
            app.payed = res.payed;
            app.price = res.price;
            app.totalDiscount = res.discount;
            app.customer = res.customer;
            app.self = res.self;
            app.decimal = res.currency ? res.currency.decimal : 0;
            app.totalPrice = parseInt(res.price.price);
            store.commit("SET_RTL", app.self.rtl.value);
            store.commit("SET_LANG", app.self.lang.value);
            if (app.self && app.self.logo) {
              app.getBase64Logo().finally(() => app.$nextTick(() => app.setheader()));
            } else {
              app.$nextTick(() => app.setheader());
            }
          });
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    async shareInvoiceLink() {
      if (!this.invoiceShareLink) return;
      const link = this.invoiceShareLink;
      const title = this.$t("invoice");
      try {
        if (navigator.share) {
          await navigator.share({ title, url: link });
          return;
        }
      } catch (err) {
        if (err && err.name === "AbortError") return;
      }
      try {
        await navigator.clipboard.writeText(link);
        this.snakbarText = this.$t("copied");
        this.snakbarColor = "green";
        this.snakbar = true;
      } catch (err) {
        this.snakbarText = link;
        this.snakbarColor = "blue";
        this.snakbar = true;
      }
    },
    getPrintFontConfig() {
      const useEnNum =
        this.$store.state.iranSansEnNum === "active" ||
        (this.$i18n && this.$i18n.locale !== "fa");
      const origin = window.location.origin;
      if (useEnNum) {
        return {
          family: "IRANSansEn",
          fontUrl: origin + "/font/YekanBakhNoEn-Regular.ttf",
        };
      }
      return {
        family: "IRANSans",
        fontUrl: origin + "/font/YekanBakhFaNum-Regular.ttf",
      };
    },
    getPrintFontFaceStyles() {
      const cfg = this.getPrintFontConfig();
      return (
        "@font-face {" +
        'font-family: "' +
        cfg.family +
        '";' +
        "font-style: normal;" +
        "font-weight: normal;" +
        'src: url("' +
        cfg.fontUrl +
        '") format("truetype");' +
        "}"
      );
    },
    getPrintStyles(direction) {
      const dir = direction || (this.$vuetify.rtl ? "rtl" : "ltr");
      const cfg = this.getPrintFontConfig();
      return (
        "<style>" +
        this.getPrintFontFaceStyles() +
        "@page { margin: 12mm; }" +
        "body { direction: " +
        dir +
        '; font-family: "' +
        cfg.family +
        '", Tahoma, Arial, sans-serif; margin: 0; padding: 12px; color: #232323; background: #fff; box-sizing: border-box; -webkit-print-color-adjust: exact; print-color-adjust: exact; }' +
        "table { border-collapse: collapse; width: 100%; background: #fff; }" +
        "table td, table th { border: 1px solid #c3c3c3; padding: 6px 8px; font-size: 13px; vertical-align: middle; }" +
        "table td:first-child, table th:first-child { border-right: 1px solid #c3c3c3; }" +
        "thead tr.payflow-header-row { display: table-row !important; }" +
        "thead tr.payflow-header-row th { border: 1px solid #c3c3c3; background: #fff; font-weight: normal; }" +
        "thead tr:last-child th { background: #f5f7fa; font-weight: 600; color: #455a64; }" +
        "tbody tr td { text-align: center; }" +
        "tbody tr:not(.payflow-tfoot-row):not(.invoice-content-row):nth-child(odd) td { background: #fff; -webkit-print-color-adjust: exact; print-color-adjust: exact; }" +
        "tbody tr:not(.payflow-tfoot-row):not(.invoice-content-row):nth-child(even) td { background: #f5f5f5; -webkit-print-color-adjust: exact; print-color-adjust: exact; }" +
        "tbody tr.payflow-tfoot-row:not(.payflow-tfoot-row--total) td { font-weight: 600; background: #fafafa; border-bottom: none; }" +
        "tbody tr.payflow-tfoot-row:not(.payflow-tfoot-row--total):first-of-type td { border-top: 1px solid #e8ecef; }" +
        "tbody tr.payflow-tfoot-row--total td { background: #e8eaed; color: #37474f; font-weight: 700; -webkit-print-color-adjust: exact; print-color-adjust: exact; }" +
        "tbody tr.payflow-tfoot-row--total .payflow-tfoot-value--total { color: #0066ff !important; }" +
        ".payflow-discount-text { color: #e53935 !important; }" +
        ".v-data-table__progress, .v-data-table-header-mobile { display: none !important; }" +
        "</style>"
      );
    },
    getPrintContent() {
      const tableRef = this.getTableRef();
      if (!tableRef) return null;
      const direction = this.$vuetify.rtl ? "rtl" : "ltr";
      return {
        direction,
        html: tableRef.$el.outerHTML,
        style: this.getPrintStyles(direction),
      };
    },
    buildPdfFileName() {
      const invoiceLabel =
        this.type !== "presale"
          ? this.$t("invoice") + " " + this.$t(this.type)
          : this.$t(this.type);
      const customerName = this.customer && this.customer.name ? this.customer.name : "";
      const invoiceNumber = this.officialNumber || this.number || "";
      return (
        invoiceLabel +
        " " +
        customerName +
        " " +
        this.$t("toNum") +
        " " +
        invoiceNumber +
        ".pdf"
      );
    },
    buildPrintDocumentHtml(content) {
      return (
        '<!DOCTYPE html><html><head><meta charset="utf-8"><title>' +
        this.$t("invoicePrint") +
        "</title>" +
        content.style +
        '</head><body style="direction:' +
        content.direction +
        '">' +
        content.html +
        "</body></html>"
      );
    },
    getCaptureScale(element) {
      const maxSide = 12000;
      const longestSide = Math.max(element.scrollWidth, element.scrollHeight, 1);
      return Math.min(2, maxSide / longestSide);
    },
    buildPdfFromCanvas(canvas) {
      const margin = PAYFLOW_A4_PAGE.MARGIN_MM;
      const contentWidth = PAYFLOW_A4_PAGE.WIDTH_MM - margin * 2;
      const contentHeight = PAYFLOW_A4_PAGE.HEIGHT_MM - margin * 2;
      const imgData = canvas.toDataURL("image/png");
      const pdf = window.jspdf.jsPDF("p", "mm", "a4");
      const imgHeight = (canvas.height * contentWidth) / canvas.width;
      let position = 0;
      let heightLeft = imgHeight;

      pdf.addImage(imgData, "PNG", margin, margin, contentWidth, imgHeight, null, "FAST");
      heightLeft -= contentHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(
          imgData,
          "PNG",
          margin,
          position + margin,
          contentWidth,
          imgHeight,
          null,
          "FAST"
        );
        heightLeft -= contentHeight;
      }

      return pdf;
    },
    waitForPrintImages(root) {
      const images = root.querySelectorAll("img");
      return Promise.all(
        Array.from(images).map(
          (img) =>
            new Promise((resolve) => {
              if (img.complete) {
                resolve();
                return;
              }
              img.onload = resolve;
              img.onerror = resolve;
            })
        )
      );
    },
    async downloadPdf() {
      const app = this;
      app.loading = true;
      let printFrame = null;

      try {
        if (!window.html2canvas || !window.jspdf) {
          throw new Error("PDF libraries not loaded");
        }

        await app.getBase64Logo();
        app.setheader();
        await app.$nextTick();
        const content = app.getPrintContent();
        if (!content) {
          throw new Error("Print table not found");
        }

        printFrame = document.createElement("iframe");
        printFrame.style.cssText =
          "position:fixed;left:-9999px;top:0;width:" +
          PAYFLOW_PRINT_VIEWPORT_WIDTH +
          "px;border:0;visibility:hidden;";
        document.body.appendChild(printFrame);

        const frameDoc = printFrame.contentDocument || printFrame.contentWindow.document;
        frameDoc.open();
        frameDoc.write(app.buildPrintDocumentHtml(content));
        frameDoc.close();

        if (frameDoc.fonts && frameDoc.fonts.ready) {
          await frameDoc.fonts.ready;
        } else if (document.fonts && document.fonts.ready) {
          await document.fonts.ready;
        }
        await app.waitForPrintImages(frameDoc.body);
        await new Promise((resolve) => setTimeout(resolve, 200));

        printFrame.style.height = Math.max(frameDoc.body.scrollHeight, 1) + "px";

        const scale = app.getCaptureScale(frameDoc.body);
        const canvas = await window.html2canvas(frameDoc.body, {
          scale,
          useCORS: true,
          allowTaint: true,
          backgroundColor: "#ffffff",
          logging: false,
          windowWidth: frameDoc.body.scrollWidth,
          windowHeight: frameDoc.body.scrollHeight,
        });

        const pdf = app.buildPdfFromCanvas(canvas);
        pdf.save(app.buildPdfFileName());
      } catch (err) {
        app.snakbarText = err.message || app.$t("paymentError");
        app.snakbarColor = "pink";
        app.snakbar = true;
      } finally {
        if (printFrame && printFrame.parentNode) {
          printFrame.parentNode.removeChild(printFrame);
        }
        app.loading = false;
      }
    },
    printInvoice() {
      var app = this;
      app.setheader();
      app.$nextTick(function () {
        const content = app.getPrintContent();
        if (!content) return;

        const WinPrint = window.open(
          "",
          "",
          "left=0,top=0,width=" +
            PAYFLOW_PRINT_VIEWPORT_WIDTH +
            ",height=900,toolbar=0,scrollbars=0,status=0"
        );
        if (!WinPrint) return;

        WinPrint.document.write(app.buildPrintDocumentHtml(content));
        WinPrint.document.close();
        WinPrint.focus();
        setTimeout(function () {
          WinPrint.print();
          WinPrint.close();
        }, 800);
      });
    },
    print() {
      this.printInvoice();
    },
    handlePayment() {
      if (this.gateway === "paymentKarinaSystem") {
        this.karinaPeyment();
      } else {
        this.payment();
      }
    },
    karinaPeyment() {
      var app = this;
      app.loading = true;
      app.$axios
        .post(this.$endpoint + "karina/pay", {
          payment: "active",
          id: app.id,
          gateway: app.gateway,
          cuid: app.$route.query.cuid,
        })
        .then((res) => {
          res = res.data;
          if (res.karina) {
            window.location.href = res.url;
          } else {
            app.snakbarColor = "pink";
            app.snakbarText =
              res.message || res.ErrorDescription || app.$t("paymentError");
            app.snakbar = true;
          }
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    payment() {
      var app = this;
      console.log(this.id, " this.id this.id this.id this.id");
      app.loading = true;
      app.$axios
        .get(this.$apipoint + "print/invoice/" + this.id, {
          params: {
            payment: "active",
            id: app.id,
            gateway: app.gateway,
            cuid: app.$route.query.cuid,
          },
        })
        .then((res) => {
          res = res.data;
          if (res.action) {
            window.location.href = res.action;
          } else {
            app.snakbarColor = "pink";
            app.snakbarText =
              res.message || res.ErrorDescription || app.$t("paymentError");
            app.snakbar = true;
          }
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
  },
};
</script>

<style scoped>
.payflow-app {
  min-height: 100vh;
  min-height: 100dvh;
  max-height: 100vh;
  max-height: 100dvh;
  overflow: hidden;
  background: #ffffff !important;
}

.payflow-app ::v-deep .v-application--wrap {
  height: 100% !important;
  min-height: 100vh !important;
  min-height: 100dvh !important;
  max-height: 100vh !important;
  max-height: 100dvh !important;
  overflow: hidden !important;
}

.payflow-app--mobile ::v-deep .v-application--wrap {
  overflow: hidden !important;
}
</style>
